export default __webpack_public_path__ + "static/media/chimeras-box.ea69236b.png";